import { render } from "./ImpersonateLogin.vue?vue&type=template&id=2bd698c6"
import script from "./ImpersonateLogin.vue?vue&type=script&lang=js"
export * from "./ImpersonateLogin.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/4schemplus/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__